/**
     * Helper for downloading files from given blob.
     * @param {Blob} blob Some file blob.
     * @param {string} filename Filename to download.
     */
export default function download(blob, filename) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
}
